export type inputSizeProps = 'md' | 'lg'

export const labelSizeDict: Record<inputSizeProps, string> = {
    md: 'text-base font-light',
    lg: 'text-lg font-normal',
}
